import { WorkingWithUsSectionStyles } from '../section.style';
import { MDSText } from '@thrivent/midwest-web';
import Image from 'next/image';
import styled from 'styled-components';

const { Content } = WorkingWithUsSectionStyles;

export const ImageDescription = styled(MDSText.BodyHeavyDefault)`
  max-width: 21rem;
  text-align: center;
`;

export const CenterContent = styled(Content)`
  display: flex;
  align-items: center;
`;

export const StyleImage = styled(Image)`
  width: 100%;
  height: 100%;
`;
